import React from 'react';
import { Briefcase } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Experience = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const positions = t.experience.positions;

  return (
    <section id="experience" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">
            {t.experience.title}
          </h2>
          <div className="w-24 h-1 bg-gray-900 mx-auto"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          {positions.map((job, index) => (
            <div key={index} className="relative pl-8 pb-12 last:pb-0">
              {index !== positions.length - 1 && (
                <div className="absolute left-[15px] top-8 bottom-0 w-0.5 bg-gray-300"></div>
              )}
              
              <div className="absolute left-0 top-2 w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center">
                <Briefcase className="w-4 h-4 text-white" />
              </div>

              <div className="bg-white p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                  <h3 className="text-xl font-serif font-semibold text-gray-900">
                    {job.position}
                  </h3>
                  <span className="text-sm font-medium text-gray-600 mt-1 md:mt-0">
                    {job.period}
                  </span>
                </div>
                <p className="text-gray-700 font-medium">
                  {job.organization}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;